export default function useTransformer<SrcType, ReturnType = SrcType>(
	ref: Ref<SrcType>,
	load: (v: SrcType) => ReturnType,
	store: (v: ReturnType) => SrcType = (value) => value as unknown as SrcType,
) {
	return computed<ReturnType>({
		get() {
			return load(ref.value);
		},
		set(value: ReturnType) {
			ref.value = store(value);
		},
	});
}
